<template>
	<div class="assesment-icon">
		<div :class="iconName()"></div>
		<div class="header3">{{ assessmentRateText }}</div>
	</div>
</template>

<script>
import { assessmentStatus } from "@/env";
export default {
	name: "assesment-icon",
	computed: {
		assessmentRateText() {
			return this.$store.getters.getAssessmentRateText;
		},
	},
	methods: {
		iconName() {
			let iconName;
			switch (this.$store.getters.getAssessmentRate) {
				case assessmentStatus.underassessed: // "Underasssesed":
					iconName = "fairly";
					break;
				case assessmentStatus.overAssessed: // "Overassessed":
					iconName = "over";
					break;
				case assessmentStatus.fairlyAssessed: // "Assesed Fairly":
					iconName = "fairly";
					break;
				// case assessmentStatus.notAssessed:// "notAssessed":
				default:
					iconName = "not_assesed";
			}
			return iconName;
		},
	},
};
</script>

<style scoped lang="scss">
.assesment-icon {
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	justify-content: flex-end;
	margin-top: 10px;
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--black);
	}
	.under,
	.fairly,
	.over,
	.not_assesed {
		width: 46px;
		margin-right: 10px;
		padding-bottom: 5px;
	}
	.under {
		content: url(/svg/under_a.svg);
	}
	.fairly {
		content: url(/svg/fairly_a.svg);
	}
	.over {
		content: url(/svg/over_a.svg);
	}
	.not_assesed {
		content: url(/svg/not_a.svg);
	}
}
@media screen and (max-width: 414px) {
	.assesment-icon {
		display: flex;
		justify-content: unset;
	}
}
</style>